import { createBrowserRouter } from 'react-router-dom';

import App, { loader as appLoader } from '../App/App';
import Home from '../App/Home/Home';
import TopicView from '../App/TopicView/TopicView';
import FaqView from '../App/FaqView/FaqView';
import { NotFound } from '../App/NotFound/NotFound';

export const getRouter = () =>
  createBrowserRouter([
    {
      path: '/',
      element: <App />,
      loader: () => appLoader(),
      children: [
        {
          index: true,
          element: <Home />
        },
        {
          path: 'topic/:id',
          element: <TopicView />,
          errorElement: <NotFound />
        },
        {
          path: 'faq/:id',
          element: <FaqView />,
          errorElement: <NotFound />
        },
        {
          path: '*',
          element: <NotFound />
        }
      ]
    }
  ]);
